/**
 * 상품 판매 가능 여부(is_active) 관련 유틸
 *
 * - 서버에서 is_active가 내려오지 않는(구버전 응답) 경우에는 판매 가능으로 간주한다.
 * - is_active가 명시적으로 false인 경우에만 구매를 차단한다.
 */

/** 판매 중지 상품 안내 문구 */
export const PRODUCT_INACTIVE_MESSAGE = '현재 판매하지 않는 상품입니다.';

/** 판매 중지 상품 버튼 라벨 */
export const PRODUCT_INACTIVE_LABEL = '판매 중지';

/**
 * 상품 구매 가능 여부
 * @param product is_active를 가진 상품(Product, ShopInfoProps, BoostUpTypes, CourseInfoType 등)
 * @returns is_active가 false이면 false, 그 외(true/undefined/null)는 true
 */
export const isProductPurchasable = (
  product?: { is_active?: boolean } | null,
): boolean => product?.is_active !== false;
